import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CameraQrScanComponent } from './camera-qr-scan.component';

@NgModule({
    declarations: [
        CameraQrScanComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CameraQrScanComponent
    ]
})
export class CameraQrScanModule {
}
